import React, { useEffect, useState } from 'react'
import Navbar from '../components/Navbar'
import { useParams } from 'react-router-dom'
import onion from '../data/onion.json';
import garlic from '../data/garlik.json';
import raisins from '../data/raisins.json';
import spices from '../data/spices.json';
import vegetable from '../data/vagetable.json';
import ContactBox from '../components/ContactBox';
import Footer from '../components/Footer';

const ProductDetails = () => {
    const { id, type } = useParams();
    const [selectedData, setSelectedData] = useState({})
    useEffect(() => {
        let data;
        switch (type) {
            case 'onion':
                data = [...onion]
                break;
            case 'garlic':
                data = [...garlic]
                break;
            case 'raisins':
                data = [...raisins]
                break;
            case 'spices':
                data = [...spices]
                break;
            case 'vegetable':
                data = [...vegetable]
                break;
            default:
                break;
        }
        data?.map(item => {
            if (item?.id == id) {
                setSelectedData(item)
            }
        })
    }, [])

    return (
        <>
            <Navbar />
            <section className="mrg_tb">
                <div className="container">

                    <div className="heading d-flex flex-column justify-content-center align-items-center mb-4">
                        <h2 className="Viga text-center  wow animate__flash" data-wow-delay="0s" data-wow-duration="1s">{selectedData?.title}<span className="cl-theme"></span></h2>
                    </div>

                    <div className="row">
                        <div className="col-md-6 my-3 my-md-0 wow animate__fadeInUp" data-wow-delay="0s" data-wow-duration="1s">
                            <div className="orgBrd StickyTop">
                                <div className="whiteBrd">
                                    <div className="grayBrd">
                                        <img src={selectedData?.image} alt="Coriander Powder Product Image" draggable="false" className="img-fluid" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 my-3 my-md-0">
                            <h2 className="Viga  wow animate__fadeInLeft" data-wow-delay="1s" data-wow-duration="1s">About the Product<span className="cl-theme">:</span></h2>
                            <div className="cusLineH mt-2 pb-5  wow animate__fadeInLeft" data-wow-delay="1s" data-wow-duration="1s">
                                {selectedData?.about}
                            </div>
                            <a href="mailto:info@integroexim.com">
                                <div className="detail-card-btn1 mb-3  wow animate__fadeInUp" data-wow-delay="1.1s" data-wow-duration="1s" data-toggle="modal" data-target="#exampleModal-1">Inquiry via Gmail</div>
                            </a>
                            <a href={`https://api.whatsapp.com/send?phone=918460024742&text=Product inquiry about \n https://integroexim.com/${type}/${id}`}>
                                <div className="detail-card-btn2  wow animate__fadeInUp" data-wow-delay="1.2" data-wow-duration="1s" data-toggle="modal" data-target="#exampleWhatsappModal-1">Inquiry via Whatsapp</div>
                            </a>

                            <img src="/images/ProductFixImage.png" alt="import-export" draggable="false" className="img-fluid my-5 d-none d-md-block  wow animate__fadeInUp" data-wow-delay="1.3s" data-wow-duration="1s" />

                            <div className="orgBD mt-5 mt-md-0  wow animate__fadeInUp" data-wow-delay="1.4s" data-wow-duration="1s">
                                <h2 className="Viga cl-w">Benefits :</h2>
                                <div className="cusLineH mt-2 pb-5">
                                    {selectedData?.benefits}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <ContactBox></ContactBox>
            <Footer></Footer>
        </>
    )
}

export default ProductDetails